import React, { useState, useEffect } from 'react'
import { getData, updateData } from '../../actions'
import {
  Grid,
  Button,
  Grow,
  TextField,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl
} from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import Filter from '../../filter/filter'

export default function UserContainer(props) {
  const [email, setEmail] = useState('')
  const [firstname, setFirstname] = useState('')
  const [lastname, setLastname] = useState('')
  const [roles, setRoles] = useState('')
  const [departments, setDepartments] = useState([])
  const [projects, setProjects] = useState([])
  const [departmentList, setDepartmentList] = useState([])
  const [projectList, setProjectList] = useState([])
  const [propertyName, setPropertyName] = useState('centerName')
  const [projectPropertyName, setProjectPropertyName] = useState('projectName')
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingProjects, setIsLoadingProjects] = useState(true)
  const [savedLoading, setSavedLoading] = useState(false)
  const [isProject, setIsProject] = useState()

  const [state, setState] = React.useState({
    checkedA: true,
    checkedB: true
  })

  const handleSwitch = event => {
    if (event.target.checked) {
      setPropertyName('centerName')
    } else {
      setPropertyName('centerCode')
    }
    setState({ ...state, [event.target.name]: event.target.checked })
  }

  const handleProjectSwitch = event => {
    if (event.target.checked) {
      setProjectPropertyName('projectName')
    } else {
      setProjectPropertyName('projectCode')
    }
    setState({ ...state, [event.target.name]: event.target.checked })
  }

  useEffect(() => {
    if (props.id) {
      userInfo()
      getDepartments()
    }
  }, [props])
  const userInfo = async () => {
    try {
      setIsLoading(true)
      const { data } = await getData(`/userInfo/${props.id}`)
      const userDepartments = []
      for (const obj of data.departments) {
        userDepartments.push({
          centerCode: obj.centerCode,
          centerName: obj.centerName
        })
      }
      setEmail(data.email)
      setFirstname(data.firstName)
      setLastname(data.lastName)
      setRoles(data.roles[0])
      setDepartments(userDepartments)
      setProjects(data.projects ? data.projects : [])
      setIsProject(data.isProject === 'Yes' ? data.isProject : 'No')
      setIsLoading(false)
      getProjects()
    } catch (e) {
      setIsLoading(false)
      props.handleClose('Cancel')
      alert('Oops something went wrong')
    }
  }

  // get department list
  const getDepartments = async () => {
    try {
      const { data } = await getData('/departments/spreadsheet/list')
      if (data.length > 0) {
        setDepartmentList(data)
      }
    } catch (e) {
      alert('Oops something went wrong')
    }
  }

  // get project list
  const getProjects = async () => {
    setIsLoadingProjects(true)
    try {
      const { data } = await getData('/projects/spreadsheet/list')
      if (data.length > 0) {
        setProjectList(data)
        setIsLoadingProjects(false)
      }
    } catch (e) {
      alert('Oops something went wrong')
      setIsLoadingProjects(false)
    }
  }

  // save to database
  const saveData = async () => {
    setSavedLoading(true)
    try {
      const approvedDepartments = []
      for (const obj of departments) {
        approvedDepartments.push({
          centerCode: obj.centerCode,
          centerName: obj.centerName,
          isApproved: true
        })
      }
      const obj = {
        email,
        firstName: firstname,
        lastName: lastname,
        roles: [roles],
        departments: approvedDepartments,
        isProject:
          roles === 'Accounting Staff' || roles === 'Accounting Manager'
            ? null
            : isProject,
        projects:
          roles === 'Accounting Staff' || roles === 'Accounting Manager'
            ? null
            : isProject === 'Yes'
              ? projects
              : null
      }
      const { data } = await updateData(`/userInfo/${props.id}`, { data: obj })
      if (data.nModified === 1) {
        setSavedLoading(false)
        props.handleClose([
          `${firstname} ${lastname}`,
          email,
          roles,
          departments
        ])
      } else {
        setSavedLoading(false)
        alert('No changes detected')
      }
    } catch (e) {
      alert('Oops something went wrong')
      console.log(e)
      setSavedLoading(false)
    }
  }
  return isLoading ? (
    <CircularProgress style={{ marginLeft: '45%' }} />
  ) : (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <TextField
            variant='standard'
            label='Email'
            size='small'
            fullWidth
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            variant='standard'
            label='Firstname'
            size='small'
            fullWidth
            value={firstname}
            onChange={e => setFirstname(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            variant='standard'
            label='Lastname'
            size='small'
            fullWidth
            value={lastname}
            onChange={e => setLastname(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormControl style={{ width: '100%' }}>
            <InputLabel>Role</InputLabel>
            <Select
              labelId='demo-simple-select-label'
              id='demo-simple-select'
              fullWidth
              value={roles}
              onChange={e => setRoles(e.target.value)}
            >
              <MenuItem value='Requestor'>Requestor</MenuItem>
              <MenuItem value='Comptroller'>Comptroller</MenuItem>
              <MenuItem value='COO'>COO</MenuItem>
              <MenuItem value='Department Head'>Department Head</MenuItem>
              <MenuItem value='Accounting Staff'>Accounting Staff</MenuItem>
              <MenuItem value='Accounting Manager'>Accounting Manager</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12}>
          {isLoading ? (
            <></>
          ) : (
            <>
              <Filter
                listData={departmentList}
                filterValue={departments}
                label='Departments'
                propertyName={propertyName}
                onChange={value => setDepartments(value)}
              />

              <FormControlLabel
                control={
                  <Switch
                    checked={state.checkedA}
                    onChange={handleSwitch}
                    name='checkedA'
                    color='primary'
                  />
                }
                label={
                  propertyName === 'centerCode' ? 'Center Code' : 'Center Name'
                }
              />
            </>
          )}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          style={
            roles === 'Accounting Staff' || roles === 'Accounting Manager'
              ? { display: 'none' }
              : {}
          }
        >
          <FormControl style={{ width: '100%' }}>
            <InputLabel id='demo-simple-select-label'>Is Project</InputLabel>
            <Select
              labelId='demo-simple-select-label'
              id='demo-simple-select'
              value={isProject}
              onChange={e => {
                console.log(e.target.value)
                setIsProject(e.target.value)
              }}
            >
              <MenuItem value='Yes'>Yes</MenuItem>
              <MenuItem value='No'>No</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          style={
            isProject === 'No'
              ? { display: 'none' }
              : roles === 'Accounting Staff' || roles === 'Accounting Manager'
                ? { display: 'none' }
                : {}
          }
        >
          {isLoadingProjects ? (
            <></>
          ) : (
            <>
              <Filter
                listData={projectList}
                filterValue={projects}
                label='Projects'
                propertyName={projectPropertyName}
                onChange={value => setProjects(value)}
              />

              <FormControlLabel
                control={
                  <Switch
                    checked={state.checkedB}
                    onChange={handleProjectSwitch}
                    name='checkedB'
                    color='primary'
                  />
                }
                label={
                  propertyName === 'projectCode'
                    ? 'Project Code'
                    : 'Project Name'
                }
              />
            </>
          )}
        </Grid>
        <Grid item xs={12} sm={12}>
          {savedLoading ? (
            <CircularProgress size={20} style={{ marginLeft: '46%' }} />
          ) : (
            <div style={{ float: 'right' }}>
              <Button
                type='button'
                size='small'
                color='primary'
                onClick={() => saveData()}
              >
                Save
              </Button>
              <Button
                type='button'
                size='small'
                color='secondary'
                onClick={() => props.handleClose('Cancel')}
              >
                Cancel
              </Button>
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  )
}
